import { render, staticRenderFns } from "./UpdateAccount.vue?vue&type=template&id=2b811f5b&scoped=true&"
import script from "./UpdateAccount.vue?vue&type=script&lang=js&"
export * from "./UpdateAccount.vue?vue&type=script&lang=js&"
import style0 from "./UpdateAccount.vue?vue&type=style&index=0&id=2b811f5b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b811f5b",
  null
  
)

export default component.exports